import StandardPage from './StandardPage';

export default StandardPage;
